import React from "react";
import { ImageProps } from "./types";
import ContentSection from "./ContentSection";
import ImageComponent from "../Image";
import cx from "classnames";

const Image: React.FC<ImageProps> = ({
  data,
  heading,
  align,
  preview = false,
}) => {
  return (
    <ContentSection
      className={cx("my-5", `align-${align || "left"}`)}
      type={data.type}
      preview={preview}
    >
      {heading}
      <ImageComponent {...data} />
    </ContentSection>
  );
};

export default Image;
